import React from 'react';
import * as Styles from 'pages/member/dns/DNS.style';
import { H6, P } from 'components/reusable-css';
import Input from 'components/input';
import Select from 'components/select';
import CustomButton from 'components/common/custom-button/custom-button';
import { Form, Formik } from 'formik';
import { addRecordsValidation, addRecordsValues } from '../util';
import { useTranslation } from 'react-i18next';

const AForm = ({ ipData, handleAddRecord, loading }) => {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={addRecordsValues('A', ipData?.ip_numbers[0]?.id)}
      validationSchema={addRecordsValidation('a')}
      onSubmit={(values, { resetForm }) => handleAddRecord(values, resetForm)}
    >
      {({ values, handleChange, handleBlur, errors, touched }) => (
        <Form>
          <Styles.SaveContainer>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string31')}</H6>
              <Input
                disabled
                placeholderClass
                styling={{ marginTop: '-7px', maxWidth: '8rem', height: '50px' }}
                name={'type'}
                value={values['type']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['type']}
                touched={touched['type']}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string32')}</H6>
              <Input
                placeholderClass
                styling={{ marginTop: '-7px', width: '100%', height: '50px' }}
                name={'name'}
                value={values['name']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['name']}
                touched={touched['name']}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerColumn>
              <H6>{t('dns/instance.string33')}</H6>
              <Select
                dns
                styling={{ width: '100%' }}
                options={ipData?.ip_numbers}
                name={'value'}
                value={values['value']}
                onChange={handleChange}
                onBlur={handleBlur}
                error={errors['value']}
                touched={touched['value']}
              />
            </Styles.SaveContainerColumn>
            <Styles.SaveContainerbtnColumn style={{ marginBottom: '0px' }}>
              <CustomButton isLoading={loading} type="submit" buttonStyles={{ height: '50px', padding: '0 2rem' }} />
            </Styles.SaveContainerbtnColumn>
          </Styles.SaveContainer>
          <P>{t('dns/instance.string34')}</P>
        </Form>
      )}
    </Formik>
  );
};
export default AForm;
